module.exports = __webpack_public_path__ + "img/check.cff19354.png";